<template>
  <@form.fieldset
    @titleKey='footer'
    @isClosed={{true}}
    @showSelectedAttributesIndicator={{true}}
    as |fieldset|
  >
    <fieldset.field
      @property='options.footerBackgroundColor'
      @type='color'
      @colorFormat='rgba'
    />

    <fieldset.field @property='options.footerFontColor' @type='color' />
    <fieldset.field @property='options.footerFontLinkColor' @type='color' />
    <fieldset.field
      @property='options.footerFontLinkColorHover'
      @type='color'
    />
    <fieldset.field @property='options.footerSocialIconColor' @type='color' />
    <fieldset.field @property='options.footerHideSocials' @type='checkbox' />
    <fieldset.field @property='footerLinks' @type='has-many' />
  </@form.fieldset>
</template>
